module.exports = __webpack_public_path__ + "static/media/dot.7e7928ad.png";